<div class="alias-select-wrapper">
  <div ngbDropdown container="body" [autoClose]="'outside'" (openChange)="onOpenChange($event)" class="border alias-select-dropdown">
    <button class="btn btn-block text-left template-alias-select-toggle" ngbDropdownToggle>
      <div class="d-flex align-items-center">
        <span class="flex-grow-1 text-truncate">
          {{ displayLabel || ('Choose available options' | translate) }}
        </span>
        <i class="fa float-right ml-2" [ngClass]="{ 'fa-chevron-down': !isOpen, 'fa-chevron-up': isOpen }"></i>
      </div>
    </button>
    <ul ngbDropdownMenu class="template-alias-select-menu">
      <li>
        <lib-filter-list-search (searchUpdated)="setSearch($event)"></lib-filter-list-search>
      </li>
      <li *ngIf="filteredOptions.length === 0" class="multi-select-no-results">
        <span translate>NO_RESULTS_FOUND</span>
      </li>
      <li *ngFor="let option of filteredOptions">
        <button
          class="btn w-100 text-left multi-select-option"
          [class.bg-light]="option.selected"
          (click)="select(option)"
        >
          <div class="d-flex align-items-center justify-content-between w-100 multi-select-option-content">
            <span class="text-truncate" ngbTooltip="{{ option.id }}" container="body">{{ option.id }}</span>
            <span
              *ngIf="option['badgeText'] as badge"
              class="multi-select-option-badge"
              [title]="badge"
              ngbTooltip="{{ badge }}"
              container="body"
            >
              {{ badge }}
            </span>
          </div>
        </button>
      </li>
    </ul>
  </div>
</div>
